// Single place for the logged-in user's display name.
// The name is cached in localStorage ("username") at login. Components that show
// it (header, sidebar, dashboard greeting) listen for USERNAME_EVENT so they
// update as soon as the profile is saved, without a logout/login.

export const USERNAME_KEY = "username";
export const USERNAME_EVENT = "username-changed";

export function getStoredUsername() {
  try {
    return (localStorage.getItem(USERNAME_KEY) || "").trim();
  } catch (e) {
    return "";
  }
}

export function setStoredUsername(name) {
  const value = (name || "").trim();
  try {
    localStorage.setItem(USERNAME_KEY, value);
  } catch (e) {
    // Storage unavailable (private mode / blocked); still notify listeners below
  }
  window.dispatchEvent(new CustomEvent(USERNAME_EVENT, { detail: value }));
}
